import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venituri-subventii',
  templateUrl: './venituri-subventii.component.html',
  styleUrls: ['./venituri-subventii.component.scss']
})
export class VenituriSubventiiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
